var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"c-footer"},[_c('div',[_vm._v("© "+_vm._s(_vm.year)+" "),_c('a',{attrs:{"href":""}},[_vm._v("Extraordinary-CBT v2.1.1")])])])}
var staticRenderFns = []

export { render, staticRenderFns }